import { Label } from "../../screens/complaint/Complaint.styled";
import { ButtonSecondary } from "../../screens/login.screen/login.styled";
import { TabContainer } from "../ServicesTab/servicestab.styled";
import { Header, InputsContainer, LabelDiv } from "./Tabs.styled";
import calendar from "../../assets/calendar.svg";
import { Table } from "../MoveOutTerminationTabs/MoveOut.styled";
import { ButtonsContainer } from "../move-inRegistrationTabs/move-inTabs.styled";
import { BaseProps } from "../move-inRegistrationTabs/interfaces";
import { FC, ReactElement, useEffect, useRef, useState } from "react";
import moment from "moment";
import { Document } from "../Temporary Components/SocialCaseModal.styled";
import PaymentPlan from "../../stores/PaymentPlanStore";

import Error from "../../components/error";
import ErrorSubscription from "../../stores/ErrorSubscriptionStore";
import General from "../../stores/GeneralStore";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from 'yup';
import { NotifyError } from "../../utils/ShowError";
import { Spinner, SpinnerRaw } from "../../components/SpinnerRaw/SpinnerRaw";
import paymentPlanStore from "../../stores/PaymentPlanStore";

interface Obj {
  [key: string]: any;
}

interface Props extends BaseProps {
  validateMakani: (makaniNumber: string) => Promise<void>;
  makaniValidation: Obj | null;
  // calculatePaymentPlan: (firstCheckDate:string)=>Promise<void>,
  calculatedPlan: Obj;
  createdPlan: Obj;
  //TODO: remove any
  createPaymentPlan: any;
  // uploadDocuments: (data: any) => Promise<void>;
  submitLoader: Boolean;
}

interface calculatedPlan {
  result: {
    calculatedAccountDetails: AccountDetails[];
  };
}

interface AccountDetails {
  accountGroup: string;
  accountType: string;
}

const PlanDetails: FC<Props> = ({
  Next,
  Previous,
  validateMakani,
  makaniValidation = null,
  calculatedPlan,
  createdPlan,
  createPaymentPlan,
  // uploadDocuments,
  submitLoader,
}: Props): ReactElement => {
  const makaniErrorId = "makaniError";
  const validationErrorId = "validationError";
  const [validationErrors, setValidationErrors] = useState<{
    [key: string]: boolean;
  }>({});
  const [uploadedFiles, setUploadedFiles] = useState<any[]>([]);
  const [preferredChequeDate, setPreferredChequeDate] = useState<string | null>(
    null
  );
  const [isValidAllField, setIsValidAllField] = useState(false);
  const [isValidMobile, setIsValidMobile] = useState(false);
  const makaniRef = useRef<HTMLInputElement | null>(null);
  const payorAuthorizedSignatoryRef = useRef<HTMLInputElement | null>(null);
  const payorMobileNumRef = useRef<HTMLInputElement | null>(null);
  const buildingNameRef = useRef<HTMLInputElement | null>(null);
  const areaRef = useRef<HTMLInputElement | null>(null);
  const propertyNumbeRef = useRef<HTMLInputElement | null>(null);
  const streetNumberRef = useRef<HTMLInputElement | null>(null);
  const emirateIdRef = useRef<HTMLInputElement | null>(null);
  const phoneNumberRegex: any =
    /^(?:00971|\+971|0)?(?:50|51|52|55|56|58|2|3|4|6|7|9)\d{7}$/;
  const monthDiff = (d1: any, d2: any) => {
    let months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth();
    months += d2.getMonth();
    return months <= 0 ? 0 : months;
  };

  // const handleFileEvent = (e: any) => {
  //   const chosenFiles = e.target.files[0];
  //   handleUpload(chosenFiles);
  // };
  const [uploadedFilesEr, setUploadedFilesEr] = useState<{ [key: string]: File }>(
    {}
  );
  const handleFileEvent = (e: React.ChangeEvent<HTMLInputElement>,
    inputName: string) => {
    const chosenFiles: any = e.target.files;
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      setUploadedFiles([...uploadedFiles, ...newFiles]);
      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        [inputName]: false,
      }))
      setUploadedFilesEr((prevFiles) => ({
        ...prevFiles,
        [inputName]: chosenFiles[0],
      }));
    }

  };

  function formatDate(date: any) {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).padStart(4, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${day} / ${month} / ${year} ${hours}:${minutes}:${seconds}`;
  }

  const handleSubmitPaymentPlan = async () => {
    const makaniNumber: any = makaniRef.current?.value;
    const dataWithError = {
      data: makaniNumber,
      errorId: "makaniError",
    };
    const res = await General.validateMakani(dataWithError);
    if (res?.message != "Success") {
      NotifyError("Invalid Makani Number");
      return;
    }

    const missingMandatoryDocuments = mandatoryDocuments.filter(
      (doc: any) => !uploadedFilesEr[doc.key]
    );
    if (missingMandatoryDocuments.length > 0) {
      const newErrors: { [key: string]: boolean } = {};
      missingMandatoryDocuments.forEach((doc) => {
        newErrors[doc.key] = true;
      });
      setValidationErrors(newErrors);

      return;
    }
    const payorMobileNum = payorMobileNumRef.current?.value;
    const payorAuthorizedSignatory = payorAuthorizedSignatoryRef.current?.value;
    const buildingName = buildingNameRef.current?.value;
    const area = areaRef.current?.value;
    const property = propertyNumbeRef.current?.value;
    const street = streetNumberRef.current?.value;
    const emirateId = emirateIdRef.current?.value;



    // Apply the condition
    if (
      calculatedPlan.result.calculatedAccountDetails &&
      calculatedPlan.result.calculatedAccountDetails.length !== 0
    ) {
      // Calculate the required values
      const numDefaultAccounts =
        calculatedPlan.result.calculatedAccountDetails.filter(
          (x: AccountDetails) =>
            x.accountGroup === "SERVICE" && x.accountType === "DEFAULT"
        ).length;

      const numServiceAccounts =
        calculatedPlan.result.calculatedAccountDetails.filter(
          (x: AccountDetails) => x.accountGroup === "SERVICE"
        ).length;

      const numConnectedAccounts =
        calculatedPlan.result.calculatedAccountDetails.filter(
          (x: AccountDetails) =>
            x.accountGroup === "CONNECTOR" && x.accountType === "CONNECTED"
        ).length;

      const numNotConnectedAccounts =
        calculatedPlan.result.calculatedAccountDetails.filter(
          (x: AccountDetails) =>
            x.accountGroup === "CONNECTOR" &&
            x.accountType === "NOT_CONNECTED"
        ).length;

      const accounts = PaymentPlan?.accounts;

      if (accounts) {
        accounts?.forEach((account) => {
          if (account.serviceFee === null) {
            account.serviceFee = 0;
          }
          if (account.vatCharges === null) {
            account.vatCharges = 0;
          }
          account.fullPaymentAmount = calculatedPlan?.result?.totalAmount;
          account.currentPaymentAmount = calculatedPlan?.result?.currentPaymentAmount;
          account.checkAmount = calculatedPlan?.result?.currentPaymentAmount;
          account.currentAmountPercent = calculatedPlan?.result?.currentAmountPercent;
          account.createdDate = calculatedPlan?.result?.createdDate;
          account.updatedDate = calculatedPlan?.result?.updatedDate;
          account.advanceServiceFee = calculatedPlan?.result?.advanceServiceFee;
          account.isActive = calculatedPlan?.result?.isActive;

        });
      }

      const data = {
        payorAuthorizedSignatory,
        makaniNumber,
        payorMobileNum,
        addrVillaOrBuilding: buildingName,
        addrArea: area,
        addrPropertyOrFlatNo: property,
        addrStreet: street,
        addrEmirate: emirateId,
        numServiceAccounts: numServiceAccounts, //it should be dyanmic
        numDefaultAccounts: numDefaultAccounts, //it should be dyanmic
        numConnectedAccounts: numConnectedAccounts, //it should be dyanmic
        numNotConnectedAccounts: numNotConnectedAccounts, //it should be dyanmic
        serviceTotalDue: calculatedPlan?.result?.serviceFee, // it should be dyanmic
        defaultTotalDue: 0,
        status: 0,
        connectedTotalDue: calculatedPlan?.result?.connectedFee, // it should be dyanmic
        notConnectedTotalDue: calculatedPlan?.result?.notConnectedFee, //self added to see  by doc
        totalAmount: calculatedPlan?.result?.totalAmount,
        // FullPaymentAmount:calculatedPlan?.result?.totalAmount,
        advanceAmount: calculatedPlan?.result?.advanceServiceFee, //TODO: mazbout henne zeton ?!!
        currentAmount: calculatedPlan?.result?.currentPaymentAmount,
        // CurrentPaymentAmount:calculatedPlan?.result?.currentPaymentAmount,
        totalCheckAmount: calculatedPlan?.result?.currentPaymentAmount,
        // CurrentAmountPercent:50.0,
        pdcCount: calculatedPlan?.result?.checkDetails.length ?? 0,
        PDCInterval: 60,
        periodInMonths: monthDiff(
          new Date(),
          new Date(
            calculatedPlan?.result?.checkDetails[
              calculatedPlan?.result?.checkDetails?.length - 1
            ]?.checkDate
          )
        ),

        checkDetails: calculatedPlan?.result?.checkDetails.map(
          (check: Obj) => {
            const date = check.checkDate
              ? moment(check.checkDate)
              : moment(preferredChequeDate).add(60 * check.sequence, "days");
            return {
              ...check,
              checkDate: date.toISOString(),
            };
          }
        ),

        // accountDetails: calculatedPlan.calculatedAccountDetails,
        accountDetails: accounts,
      };

      await createPaymentPlan(data, uploadedFiles);


    } else {
      return null;
    }


    // }
  };

  useEffect(() => {
    ErrorSubscription.unSubscribeAll();
  }, [makaniValidation, makaniRef]);
  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;


  const validationSchema = Yup.object().shape({
    makani: Yup.string().required(General?.codeLabels['cm_requirederr']?.label).matches(/^[0-9]+$/, General?.codeLabels['cm_numbererror']?.label).min(10, General?.codeLabels['cm_poboxmin']?.label).max(10, General?.codeLabels['cm_num_max']?.label),
    mobile: Yup.string().matches(/^[0-9]{10}$/, 'Invalid mobile number').required(General?.codeLabels['cm_nocentermobilenumber']?.label),
    authorisedSignatoryName: Yup.string().matches(/^[a-zA-Z\u0600-\u06FF\u0900-\u097F ,&/]+$/, General?.codeLabels["cm_invalid_name"]?.label ? General?.codeLabels["cm_invalid_name"]?.label : "Invalid Name").required(General?.codeLabels['cm_requirederr'].label),
    propertyNumber: Yup.string().required(General?.codeLabels['cm_nocflatnovalidation']?.label).matches(/^[0-9]+$/, General?.codeLabels['cm_numbererror']?.label),
    buildingName: Yup.string().matches(/^[a-zA-Z\u0600-\u06FF\u0900-\u097F ,&/]+$/, General?.codeLabels["cm_invalid_name"]?.label ? General?.codeLabels["cm_invalid_name"]?.label : "Invalid Name").required(General?.codeLabels['cm_nocbuildingnamevalidation']?.label),
    streetName: Yup.string().matches(/^[a-zA-Z\u0600-\u06FF\u0900-\u097F ,&/]+$/, General?.codeLabels["cm_invalid_name"]?.label ? General?.codeLabels["cm_invalid_name"]?.label : "Invalid Name").required(General?.codeLabels['cm_requirederr']?.label),
    are: Yup.string().required(General?.codeLabels['cm_requirederr']?.label),
    emirate: Yup.string().required(General?.codeLabels['cm_requirederr']?.label),
  });
  const mandatoryDocuments = [
    { key: "emiratesIdFile", label: "Emirates ID" },
    { key: "makaniCertificate", label: "Makani Certificate" },

    { key: "tradeLicense", label: "Trade License" },
    { key: "creditreport", label: "Credit Report" },
  ];
  return (
    <TabContainer style={{ width: "100%" }}>
      <Header
        style={{
          marginBottom: "30px",
        }}
      >
        <div style={{ width: "70%", marginTop: "30px" }}>
          <span
            style={{
              fontSize: `${1.5 * General.accessibility.fontSize}rem`,
              fontWeight: "700",
              lineHeight: "32px",
              color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
            }}
          >
            {General?.codeLabels["cm_pdc_paymentplantitle"]?.label !== undefined
              ? General?.codeLabels["cm_pdc_paymentplantitle"]?.label
              : "PDC Payment Plan"}
          </span>
          <span
            style={{
              fontSize: `${0.875 * General.accessibility.fontSize}rem`,
              fontStyle: "normal",
              lineHeight: "14px",
              fontWeight: "400",
              width: "100%",
              color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
            }}
          >
            {General?.codeLabels["cm_pdc_info"]?.label ? General?.codeLabels["cm_pdc_info"]?.label : 'Review and confirm first/upfront payment and the PDC cheque details'}
          </span>
        </div>
        <p style={{ width: "30%" }}></p>
      </Header>



      <table
        style={{
          borderSpacing: "0",
          marginTop: "20px",
        }}
      >
        <thead
          style={{
            margin: "0",
          }}
        >
          <tr
            style={{
              backgroundColor: contrast?.contrastBackground
                ? contrast?.contrastBackground
                : "#edf4f6",
            }}
          >
            <th
              style={{
                fontSize: `${0.875 * General.accessibility.fontSize}rem`,
                fontWeight: "700",
                display: "flex",
                justifyContent: "space-between",
                color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
              }}
            >
              {General?.codeLabels["cm_pdcpaymentaccounts"]?.label !== undefined
                ? General?.codeLabels["cm_pdcpaymentaccounts"]?.label
                : "Accounts"}
            </th>
            <th
              style={{
                textAlign: "right",
                fontSize: `${General.accessibility.fontSize}rem`,
                color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
              }}
            >
              {General?.codeLabels["cm_pdc_amount"]?.label !== undefined
                ? General?.codeLabels["cm_pdc_amount"]?.label
                : "Amount"}{" "}
              (AED)
            </th>
          </tr>
        </thead>
        <tbody>
          <tr  style={{ borderBottom: `1px solid ${contrast?.contrastColor ? contrast?.contrastColor : ColorAss}` }}>
            <td
              style={{
                fontSize: `${General.accessibility.fontSize}rem`,
                color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
              }}
            >
              {General?.codeLabels["cm_pdc_servicefees"]?.label !== undefined
                ? General?.codeLabels["cm_pdc_servicefees"]?.label
                : "Service Fee"}
            </td>
            <td
              style={{
                textAlign: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA" ? "left" : "right",
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                fontSize: `${General.accessibility.fontSize}rem`,
                color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
              }}
            >
              {" "}
              {calculatedPlan?.result?.serviceFee}
            </td>
          </tr>

          <tr>
            <td
              style={{
                fontSize: `${General.accessibility.fontSize}rem`,
                color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
              }}
            >
              {General?.codeLabels["cm_nocconnfee"]?.label !== undefined
                ? General?.codeLabels["cm_nocconnfee"]?.label
                : "Connection Fee"}
            </td>
            <td
              style={{
                textAlign: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA" ? "left" : "right",
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                fontSize: `${General.accessibility.fontSize}rem`,
                color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
              }}
            >
              {calculatedPlan?.result?.connectedFee}
            </td>
          </tr>
          <tr>
            <td
              style={{
                fontSize: `${General.accessibility.fontSize}rem`,
                color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
              }}
            >
              {General?.codeLabels["cm_connection_connected"]?.label ? General?.codeLabels["cm_connection_connected"]?.label : 'Connection-Fee Connected'}
            </td>
            <td
              style={{
                textAlign: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA" ? "left" : "right",
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                fontSize: `${General.accessibility.fontSize}rem`,
                color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
              }}
            >
              {calculatedPlan?.result?.connectedFee}
            </td>
          </tr>
          <tr>
            <td
              style={{
                fontSize: `${General.accessibility.fontSize}rem`,
                color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
              }}
            >
              {General?.codeLabels["cm_advance_fee"]?.label ? General?.codeLabels["cm_advance_fee"]?.label : 'Advance Service Charges'}
            </td>
            <td
              style={{
                textAlign: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA" ? "left" : "right",
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                fontSize: `${General.accessibility.fontSize}rem`,
                color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
              }}
            >
              {calculatedPlan?.result?.advanceServiceFee}
            </td>
          </tr>
          <tr
            style={{
              background: contrast?.contrastColor ? contrast?.contrastColor : "rgba(229, 239, 242, 0.7)",
              mixBlendMode: "normal",

            }}
          >
            <td
              style={{
                fontWeight: "700",
                fontSize: `${0.875 * General.accessibility.fontSize}rem`,
                lineHeight: "16px",
                color: contrast?.contrastBackground ? contrast?.contrastBackground : ColorAss
              }}
            >
              {General?.codeLabels["cm_total_amt"]?.label !== undefined
                ? General?.codeLabels["cm_total_amt"]?.label
                : "Total Amount"}
            </td>
            <td
              style={{
                textAlign: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA" ? "left" : "right",
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                fontWeight: "700",
                fontSize: `${0.875 * General.accessibility.fontSize}rem`,
                lineHeight: "16px",
                color: contrast?.contrastBackground ? contrast?.contrastBackground : ColorAss
              }}
            >
              {calculatedPlan?.result?.totalAmount}
            </td>
          </tr>
          <tr>
            <td
              style={{
                fontSize: `${General.accessibility.fontSize}rem`,
                color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
              }}
            >
              {General?.codeLabels["cm_upfront"]?.label ? General?.codeLabels["cm_upfront"]?.label : 'Current / Upfront Payment Amount'}
            </td>
            <td
              style={{
                textAlign: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA" ? "left" : "right",
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                fontSize: `${General.accessibility.fontSize}rem`,
                color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
              }}
            >
              {calculatedPlan?.result?.currentPaymentAmount}
            </td>
          </tr>
        </tbody>
      </table>

      {calculatedPlan && calculatedPlan?.result?.checkDetails ? (
        <>
          <p
            style={{
              fontWeight: "bold",
              fontSize: `${1.3 * General.accessibility.fontSize}rem`,
              color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
            }}
          >
            {General?.codeLabels["cm_pdc_chequedetails"]?.label !== undefined
              ? General?.codeLabels["cm_pdc_chequedetails"]?.label
              : "Cheque Details"}
          </p>
          <Table lastChild={true}>
            <thead>
              <tr style={{
                background: contrast?.contrastColor ? contrast?.contrastColor : "rgba(229, 239, 242, 0.7)",
                mixBlendMode: "normal",

              }}>
                <th
                  style={{
                    fontSize: `${General.accessibility.fontSize}rem`,
                    color: contrast?.contrastBackground
                      ? contrast?.contrastBackground
                      : ColorAss,
                  }}
                >
                  {General?.codeLabels["cm_pdc_checknumber"]?.label !==
                    undefined
                    ? General?.codeLabels["cm_pdc_checknumber"]?.label
                    : "Cheque Number"}
                </th>
                {/* <th>Cheque Date</th> */}
                <th
                  style={{
                    textAlign: "end",
                    width: "20vw",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    color: contrast?.contrastBackground
                      ? contrast?.contrastBackground
                      : ColorAss,
                  }}
                >
                  {General?.codeLabels["cm_pdc_chequeamount"]?.label !==
                    undefined
                    ? General?.codeLabels["cm_pdc_chequeamount"]?.label
                    : "Cheque Amounts (AED)"}
                </th>
              </tr>
            </thead>
            <tbody>
              {calculatedPlan?.result?.checkDetails.map((check: Obj) => {
                const date = check.checkDate
                  ? moment(check.checkDate)
                  : moment(preferredChequeDate).add(
                    60 * check.sequence,
                    "days"
                  );
                return (
                  <tr
                  style={{ borderBottom: `1px solid ${contrast?.contrastColor ? contrast?.contrastColor : ColorAss}` }}>
                    <td
                      style={{
                        fontSize: `${General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : ColorAss,
                        background: contrast?.contrastBackground ? contrast?.contrastBackground : "",
                      }}
                    >
                      {General?.codeLabels["cm_pdc_cheque"]?.label !== undefined
                        ? General?.codeLabels["cm_pdc_cheque"]?.label
                        : "Cheque"}
                      {check.sequence}
                    </td>
                    <td
                      style={{
                        fontSize: `${General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : ColorAss,
                        textAlign: "end",
                        background: contrast?.contrastBackground ? contrast?.contrastBackground : "",
                      }}
                    >
                      {check.checkAmount}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </>
      ) : null}
      <br />
      {/* <Error id={makaniErrorId} /> */}
      <Error id={validationErrorId} />
      {isValidAllField && (
        <h5
          id="err"
          style={{
            fontSize: `${General.accessibility.fontSize}rem`,
            color: contrast?.contrastColor ? contrast?.contrastColor : "red",
          }}
        >
          *Please make sure to submit all required fields.
        </h5>
      )}
      {isValidMobile && (
        <h5
          id="err"
          style={{
            fontSize: `${General.accessibility.fontSize}rem`,
            color: contrast?.contrastColor ? contrast?.contrastColor : "red",
          }}
        >
          *Please Enter Valid Mobile Number
        </h5>
      )}


      <Formik
        initialValues={{
          makani: '',
          mobile: '',
          authorisedSignatoryName: '',
          propertyNumber: '',
          buildingName: '',
          streetName: '',
          are: '',
          emirate: '',

        }}
        validationSchema={validationSchema}
        onSubmit={(values, { setSubmitting }) => {
          setTimeout(() => {
            // alert(JSON.stringify(values, null, 2));
            handleSubmitPaymentPlan();
            setSubmitting(false);
          }, 400);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          /* and other goodies */
        }) => (
          <form onSubmit={handleSubmit}>
            <InputsContainer
              style={{
                marginTop: "30px",
                display: General?.isLargeScreen ? "row" : "flex",
                flexDirection: General?.isLargeScreen ? "row" : "column",
                width: General?.isLargeScreen ? "" : "100%"
              }}>
              <div
                className="wholeContainer"
                style={{
                  display: "flex",
                  gap: "3rem",
                  marginBottom: "40px",
                  flexDirection: General?.isLargeScreen ? "row" : "column",
                }}
              >
                <div
                  style={{ display: "flex", flexDirection: "column", gap: "2rem" }}
                  className="2 buttons"
                >
                  <Label
                    style={{
                      fontSize: `${General.accessibility.fontSize}rem`,
                      color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
                      lineHeight: "16px",
                      gap: "0.2rem",
                      fontStyle: "normal",
                      fontWeight: "700",
                    }}
                  >
                    {General?.codeLabels["cm_pdc_makaninumber"]?.label !== undefined
                      ? General?.codeLabels["cm_pdc_makaninumber"]?.label
                      : "Makani Number"}{" "}
                    *
                    <Field
                      style={{
                        height: "46px",
                        width: General?.isLargeScreen ? "528px" : "100%",
                        padding: "10px",
                        color: contrast?.contrastBackground ? contrast?.contrastBackground : ColorAss,
                        background: contrast?.contrastColor ? contrast?.contrastColor : "",
                      }}
                      className="custom-placeholder"
                      type="text"
                      placeholder={General?.codeLabels["cm_pdc_makaninumber"]?.label ? General?.codeLabels["cm_pdc_makaninumber"]?.label : 'Enter 10 Digit Makani Number'}
                      name='makani'
                      innerRef={makaniRef}
                    // onBlur={(e:any) => {
                    //   e.target.value && validateMakani(e.target.value);
                    // }}
                    />
                    <div style={{ height: '0.5rem' }}>
                      <ErrorMessage
                        name="makani"
                        component="div"
                        className="error-message"
                      />
                    </div>
                  </Label>
                  <Label
                    style={{
                      width: General?.isLargeScreen ? "528px" : "100%",
                      height: "46px",
                      fontSize: `${General.accessibility.fontSize}rem`,
                      color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
                      lineHeight: "16px",
                      gap: "0.2rem",
                      fontStyle: "normal",
                      fontWeight: "700",
                    }}
                  >
                    {General?.codeLabels["cm_authorise_person"]?.label ? General?.codeLabels["cm_authorise_person"]?.label : 'Authorised Signatory Name *'}
                    <Field
                      style={{
                        height: "46px", padding: "10px", color: contrast?.contrastBackground ? contrast?.contrastBackground : ColorAss,
                        background: contrast?.contrastColor ? contrast?.contrastColor : "",
                      }}
                      type="text"
                      placeholder= {General?.codeLabels["cm_authorise_person"]?.label ? General?.codeLabels["cm_authorise_person"]?.label : 'Authorised Signatory Name *'}
                      innerRef={payorAuthorizedSignatoryRef}
                      name="authorisedSignatoryName"
                      className="custom-placeholder"
                    />
                    <div style={{ height: '0.5rem' }}>
                      <ErrorMessage
                        name="authorisedSignatoryName"
                        component="div"
                        className="error-message"
                      />
                    </div>
                  </Label>
                  <Label
                    style={{
                      width: General?.isLargeScreen ? "528px" : "100%",
                      height: "46px",
                      fontSize: `${General.accessibility.fontSize}rem`,
                      color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
                      lineHeight: "16px",
                      gap: "0.2rem",
                      fontStyle: "normal",
                      fontWeight: "700",
                    }}
                  >
                    {General?.codeLabels["cm_mob_buildng"]?.label !== undefined
                      ? General?.codeLabels["cm_mob_buildng"]?.label
                      : "Building Name"}
                    <Field
                      style={{ height: "46px", padding: "10px",color: contrast?.contrastBackground ? contrast?.contrastBackground:ColorAss,
                        background: contrast?.contrastColor ? contrast?.contrastColor :"", }}
                      type="text"
                      className="custom-placeholder"
                      placeholder={General?.codeLabels["cm_mob_buildng"]?.label !== undefined
                        ? General?.codeLabels["cm_mob_buildng"]?.label
                        : "Building Name"}
                      name="buildingName"
                      innerRef={buildingNameRef}
                    />
                    <div style={{ height: '0.5rem' }}>
                      <ErrorMessage
                        name="buildingName"
                        component="div"
                        className="error-message"
                      />
                    </div>
                  </Label>
                  <Label
                    style={{
                      width: General?.isLargeScreen ? "528px" : "100%",
                      height: "46px",
                      fontSize: `${General.accessibility.fontSize}rem`,
                      color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
                      lineHeight: "16px",
                      gap: "0.2rem",
                      fontStyle: "normal",
                      fontWeight: "700",
                    }}
                  >
                    {General?.codeLabels["cm_pdc_area_name"]?.label !== undefined
                      ? General?.codeLabels["cm_pdc_area_name"]?.label
                      : "Area"}
                    <Field
                      style={{ height: "46px", padding: "10px", color: contrast?.contrastBackground ? contrast?.contrastBackground:ColorAss,
                        background: contrast?.contrastColor ? contrast?.contrastColor :"",}}
                      className="custom-placeholder"
                      type="text"
                      name="are"
                      placeholder={General?.codeLabels["cm_pdc_area_name"]?.label !== undefined
                        ? General?.codeLabels["cm_pdc_area_name"]?.label
                        : "Area"}
                      innerRef={areaRef}
                    />
                    <div style={{ height: '0.5rem' }}>
                      <ErrorMessage
                        name="are"
                        component="div"
                        className="error-message"
                      />
                    </div>
                  </Label>
                </div>
                <div
                  style={{ display: "flex", flexDirection: "column", gap: "2rem" }}
                  className="2 buttons"
                >
                  <Label
                    style={{
                      width: General?.isLargeScreen ? "528px" : "100%",

                      fontSize: `${General.accessibility.fontSize}rem`,
                      color: contrast?.contrastColor ? contrast?.contrastColor :ColorAss,
                      lineHeight: "16px",
                      gap: "0.2rem",
                      fontStyle: "normal",
                      fontWeight: "700",
                    }}
                  >
                    {General?.codeLabels["cm_payer_mobile"]?.label ? General?.codeLabels["cm_payer_mobile"]?.label : 'Payer’s Mobile Number *'}
                    <Field
                      style={{ height: "46px", padding: "10px",color: contrast?.contrastBackground ? contrast?.contrastBackground:ColorAss,
                        background: contrast?.contrastColor ? contrast?.contrastColor :"", }}
                      className="custom-placeholder"
                      type="tel"
                      placeholder={General?.codeLabels["cm_payer_mobile"]?.label ? General?.codeLabels["cm_payer_mobile"]?.label : 'Payer’s Mobile Number *'}
                      innerRef={payorMobileNumRef}
                      name="mobile"
                    />
                    <div style={{ height: '0.5rem' }}>
                      <ErrorMessage
                        name="mobile"
                        component="div"
                        className="error-message"
                      />
                    </div>
                  </Label>
                  <Label
                    style={{
                      width: General?.isLargeScreen ? "528px" : "100%",
                      height: "46px",
                      fontSize: `${General.accessibility.fontSize}rem`,
                      color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
                      lineHeight: "16px",
                      gap: "0.2rem",
                      fontStyle: "normal",
                      fontWeight: "700",
                    }}
                  >
                    {General?.codeLabels["cm_pdc_flat_number"]?.label !== undefined
                      ? General?.codeLabels["cm_pdc_flat_number"]?.label
                      : "Property Number/Flat No"}
                    <Field
                      style={{ height: "46px", padding: "10px",color: contrast?.contrastBackground ? contrast?.contrastBackground:ColorAss,
                        background: contrast?.contrastColor ? contrast?.contrastColor :"", }}
                      className="custom-placeholder"
                      type="text"
                      placeholder={General?.codeLabels["cm_pdc_flat_number"]?.label !== undefined
                        ? General?.codeLabels["cm_pdc_flat_number"]?.label
                        : "Property Number/Flat No"}
                      innerRef={propertyNumbeRef}
                      name="propertyNumber"
                    />
                    <div style={{ height: '0.5rem' }}>
                      <ErrorMessage
                        name="propertyNumber"
                        component="div"
                        className="error-message"
                      />
                    </div>
                  </Label>
                  <Label
                    style={{
                      width: General?.isLargeScreen ? "528px" : "100%",
                      height: "46px",
                      fontSize: `${General.accessibility.fontSize}rem`,
                      color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
                      lineHeight: "16px",
                      gap: "0.2rem",
                      fontStyle: "normal",
                      fontWeight: "700",
                    }}
                  >
                    {General?.codeLabels["cm_land_mark"]?.label !== undefined
                      ? General?.codeLabels["cm_land_mark"]?.label
                      : "Street"}
                    <Field
                      style={{ height: "46px", padding: "10px",color: contrast?.contrastBackground ? contrast?.contrastBackground:ColorAss,
                        background: contrast?.contrastColor ? contrast?.contrastColor :"", }}
                      className="custom-placeholder"
                      type="text"
                      placeholder={General?.codeLabels["cm_land_mark"]?.label !== undefined
                        ? General?.codeLabels["cm_land_mark"]?.label
                        : "Street"}
                      innerRef={streetNumberRef}
                      name="streetName"
                    />
                    <div style={{ height: '0.5rem' }}>
                      <ErrorMessage
                        name="streetName"
                        component="div"
                        className="error-message"
                      />
                    </div>
                  </Label>
                  <Label
                    style={{
                      width: General?.isLargeScreen ? "528px" : "100%",
                      height: "46px",
                      fontSize: `${General.accessibility.fontSize}rem`,
                      color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
                      lineHeight: "16px",
                      gap: "0.2rem",
                      fontStyle: "normal",
                      fontWeight: "700",
                    }}
                    className="custom-placeholder"
                  >
                    {General?.codeLabels["cm_emirate"]?.label !== undefined
                      ? General?.codeLabels["cm_emirate"]?.label
                      : "Emirate"}
                    <Field
                      style={{ height: "46px", padding: "10px", color: contrast?.contrastBackground ? contrast?.contrastBackground:ColorAss,
                        background: contrast?.contrastColor ? contrast?.contrastColor :"", }}
                      className="custom-placeholder"
                      type="text"
                      placeholder={General?.codeLabels["cm_emirate"]?.label !== undefined
                        ? General?.codeLabels["cm_emirate"]?.label
                        : "Emirate"}
                      name="emirate"
                      pattern="^[a-zA-Z\u0600-\u06FF\u0900-\u097F ]+$"
                      innerRef={emirateIdRef}
                    />
                    <div style={{ height: '0.5rem' }}>
                      <ErrorMessage
                        name="emirate"
                        component="div"
                        className="error-message"
                      />
                    </div>
                  </Label>
                </div>
              </div>
              <br />

              <div
                style={{
                  gap: "2rem",
                  display: "flex",
                  marginBottom: "20px",
                }}
              >
                <div
                  style={{
                    width: "535px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "1.5rem",
                  }}
                  className="first2"
                >
                  {mandatoryDocuments.map((doc: any) => (
                    <div key={doc.key}>
                      <Document
                        exists={uploadedFiles[doc.key] !== undefined}
                        mainText={doc.label}
                        subText={"Mandatory Document"}
                        onChange={(e) => handleFileEvent(e, doc.key)}
                        inputName={doc.key}
                      />
                      {validationErrors[doc.key] && (
                        <p
                          style={{
                            color: "red",
                            margin: "4px 0 0 0",
                            fontWeight: "bold",
                          }}
                        >
                          {General?.codeLabels["cm_upload_file"]?.label ? General?.codeLabels["cm_upload_file"]?.label : 'Please uploadType Here'} {doc.label}
                        </p>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </InputsContainer>



            <br />
            <span
              style={{
                fontWeight: "bold",
                fontSize: `${General.accessibility.fontSize}rem`,
                color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
              }}
            >
              {General?.codeLabels["cm_mob_info"]?.label !== undefined
                ? General?.codeLabels["cm_mob_info"]?.label
                : "Information"}
              :{" "}
            </span>
            <span
              style={{
                width: "50%",
                fontSize: `${0.875 * General.accessibility.fontSize}rem`,
                fontWeight: "400",
                lineHeight: "20px",
                marginBottom: "20px",
                color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
              }}
            >
              {General?.codeLabels["cm_pdc_sum"]?.label ? General?.codeLabels["cm_pdc_sum"]?.label : 'Makani Number is mandatory for the individual resident customer Enterthe the Office Makani Number if the request for commercial purpose Credit score 4 to 5 star is required to be eligible for the PDC plan'}
            </span>
            <hr style={{ width: "100%", marginBottom: "27px" }} />
            <div style={{ display: "flex", gap: "20px", flexDirection: General?.isLargeScreen ? "row" : "column" }}>
              <ButtonSecondary
                style={{
                  height: "50px",
                  padding: "auto",
                  fontSize: `${General.accessibility.fontSize}rem`,
                  color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
                  borderColor: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
                  background: contrast?.contrastBackground ? contrast?.contrastBackground : "#fff",
                }}
                onClick={Previous}
              >
                {General?.codeLabels["cm_back"]?.label !== undefined
                  ? General?.codeLabels["cm_back"]?.label
                  : "BACK"}
              </ButtonSecondary>
              <ButtonSecondary
                style={{
                  height: "50px",
                  background: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
                  fontSize: `${General.accessibility.fontSize}rem`,
                  color: contrast?.contrastBackground ? contrast?.contrastBackground : "#fff",
                  border: "none",
                }}
                // onClick={handleSubmitPaymentPlan}
                type="submit" disabled={isSubmitting}
              >
                {submitLoader ? <Spinner width="30px" height="30px" /> : General?.codeLabels["cm_next"]?.label !== undefined
                  ? General?.codeLabels["cm_next"]?.label
                  : "NEXT"}
              </ButtonSecondary>
            </div>
          </form>
        )}
      </Formik>
    </TabContainer>
  );
};

export default PlanDetails;
